import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

// import Form1065 from '../resources/tax-extension/form-7004-for-form-1065';

const Form565 = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };
  // const [scrollIndex, setScrollIndex] = useState(0);
  // const [closeSticky, setCloseSticky] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [progress, setProgress] = useState(0);
  // const handleStickyClose = (): void => {
  //   setCloseSticky(true);
  // };
  const images = [
    <img
      src="/assets/images/f568-add-partner-img.webp"
      key="first"
      alt="Add Partnership"
      id="loading1"
      className="details-images"
    />,
    <img
      src="/assets/images/f568-details-img.webp"
      key="second"
      alt="Details"
      className="details-images"
    />,
    <img
      src="/assets/images/f568-deductions-img.webp"
      key="third"
      alt="Deductions"
      className="details-images"
    />,

    <img
      src="/assets/images/f568-schedule-l-img.webp"
      key="fouth"
      alt="Schedule 1"
      className="details-images"
    />,
    // <img
    //   src="/assets/images/f568-state-tax-img.webp"
    //   key="fourth"
    //   alt="K-1 Allocations"
    //   className="details-images"
    // />,
  ];
  const loader = ['loading1', 'loading2', 'loading3', 'loading4'];
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === images.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === loader.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);

  // refs
  // const leftScrollRef = useRef(null)s; // the scrollable container
  // const sectionsRef = useRef<any>([]); // array of section elements

  // state for which image to show
  // const [scrollIndex, setScrollIndex] = useState(0);

  // example images (replace these paths with your real images)

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           const target = entry.target as HTMLElement;
  //           const index = Number(target.dataset.index);
  //           setScrollIndex(index);
  //         }
  //       });
  //     },
  //     {
  //       threshold: 0.6, // observe viewport, not left container
  //     }
  //   );

  //   sectionsRef.current.forEach((sec: HTMLElement) => {
  //     if (sec) observer.observe(sec);
  //   });

  //   return () => observer.disconnect();
  // }, []);
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 16));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 16)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="California FTB Form 568 | File CA LLC Tax Return "
          description="File California FTB Form 568 online with TaxZerone. Prepare and e-file your California LLC tax return securely, with automatic Schedule K-1 preparation."
          keywords=""
          canonical="business-tax/efile-california-form-568/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount=""
          ogShareImg=""
        />
      }
    >
      {/* <Hidden smDown>
        {!closeSticky && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong>Thank you</strong> for trusting{' '}
                    <b style={{ fontWeight: 600, color: '#213e99' }}>
                      TaxZerone
                    </b>{' '}
                    with your <strong> Form 1065</strong> filing.
                  </Typography>
                </Box>  */}
      {/* <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden> */}
      {/* </Stack>
            </Container>
          </Box>
        )}
      </Hidden> */}
      <BusinessTaxSubMenu />
      {/* <ExitPopup1065 /> */}
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #1f6666, #106ad2)',
            p: 1.5,
            px: 4,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 20, lg: '1.25rem' },
                color: '#d9d9d9',
              }}
            >
              <strong>📢Attention Partnerships! </strong> E-file your{' '}
              <span style={{ fontWeight: 600, color: '#ffbb00' }}>
                {' '}
                2025 Form 1065
              </span>{' '}
              online and securely deliver Schedule K-1s to partners.
            </Typography>
            <Box sx={{}}> */}
      {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  March 16, 2026
                </span>
                ):
              </Typography> */}
      <Countdown date={lastDayTaxSeason} renderer={renderer} />
      {/* </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                sx={{
                  backgroundColor: '#ee4266',
                  '&:hover, &:focus': {
                    backgroundColor: '#8338ec',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button> */}
      {/* <Typography
                variant="body2"
                sx={{ textAlign: 'center', mt: 1, color: '#fff' }}
              >
                {' '}
                <b style={{ color: '#fff' }}> Save 10%</b> with code{' '}
                <b style={{ color: '#f4d58d' }}> TZOTE10</b>
              </Typography> */}
      {/* </Box>
          </Stack>
        </Box>
      </Container> */}

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File{' '}
                <span className="highlight-container">
                  <span className="highlight">California Form 568</span>
                </span>{' '}
                Online
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                California LLCs must file Form 568 with the California Franchise
                Tax Board (FTB) to stay compliant with state tax laws. TaxZerone
                simplifies the process with accurate preparation.
              </Typography>
              <Stack
                direction={{ xs: 'column', sm: 'row', md: 'row' }}
                spacing={{ xs: 0, md: 4 }}
              >
                <Box sx={{ width: { xs: '100%', md: 300 } }}>
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText>FTB-Compliant Filing</ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText>Built-in Accuracy Checks</ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Box sx={{ width: { xs: '100%', md: '70%' } }}>
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText>
                        Automatic Schedule K-1 (568) Generation
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1d1917',
                        }}
                      >
                        <CheckCircleIcon />
                      </ListItemIcon>
                      <ListItemText>
                        Trusted by California LLC Owners, Tax Professionals &
                        CPAs
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Stack>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 1 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form568`}
                  >
                    Start Filing Form 568
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/ftb-logo.webp" />
                      <source srcSet="/assets/images/ftb-logo.png" />
                      <Box
                        component="img"
                        src="/assets/images/ftb-logo.png"
                        loading="lazy"
                        alt="FTB e-file provider"
                        width={80}
                        height={79}
                        sx={{
                          width: { xs: 70, md: 80 },
                          height: { xs: 69, md: 79 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              />
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f568-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/f568-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/f568-landing-img.png"
                  alt="File California Form 568 Online"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f565-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/f565-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/f565-landing-img-sm.png"
                  alt="File California Form 565 Online"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File California Form 568 for Just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30, md: 40 },
                  }}
                >
                  $69.99{' '}
                </Box>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 17, md: 17, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                One flat fee. No hidden charges. Your complete CA Form 568
                E-filing includes Schedule K-1 (568) preparation for all members
                and direct submission to the California Franchise Tax Board.
              </Typography>
            </Box>
            {/* <Typography variant="body1">Add-on services:</Typography>
              <Box component={'ul'} sx={{ mt: -0.1 }}>
                <li>
                  Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#ffffffff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $1.75
                  </Box>{' '}
                  per recipient
                </li>
                <li>
                  {' '}
                  ZeroneVault Digital Delivery: Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#fffad1ff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $0.50
                  </Box>{' '}
                  per recipient{' '}
                </li>
              </Box> */}

            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 150 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form568`}
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                Get Started
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                    mb: 0.8,
                  }}
                >
                  What Is California Form 568?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  California Form 568, the official Limited Liability Company
                  Return of Income, is the annual state tax return filed by LLCs
                  with the{' '}
                  <Link
                    target="_blank"
                    href="https://www.ftb.ca.gov/"
                    sx={{ color: '#0202ff' }}
                  >
                    California Franchise Tax Board (FTB)
                  </Link>
                  . It reports the LLC’s California income, deductions, credits,
                  and other required tax information for the year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  LLCs that do business in California, are organized in
                  California, or earn California-source income generally must
                  file Form 568 each year, even if they had little activity or
                  operated at a loss. The form is also used to report the annual
                  LLC tax, LLC fee (if applicable), and each member’s share of
                  California income.
                </Typography>

                <Alert
                  severity="warning"
                  icon={false}
                  sx={{
                    mb: 0,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    fontStyle: 'italic',
                  }}
                >
                  <b> Important: </b> Filing a federal return, such as{' '}
                  <Link
                    target="_blank"
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    IRS Form 1065
                  </Link>{' '}
                  or Form 1040 Schedule C, does not satisfy your California LLC
                  filing requirement. You must file{' '}
                  <span style={{ fontWeight: 600 }}>CA FTB Form 568</span>{' '}
                  separately with the California Franchise Tax Board (FTB).
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                  ml: { xs: 0, md: 10 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/california-form-568-img.webp" />
                  <source srcSet="/assets/imagescalifornia-form-568-img.png" />
                  <img
                    src="/assets/images/california-form-568-img.png"
                    alt="What Is California Form 568?"
                    className="img-responsive"
                    loading="lazy"
                    width={600}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',

          pb: 6,
          pt: 1,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ md: 12, xs: 12 }}
              sx={{ mt: 4, justifyContent: 'center' }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 3,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                California vs Federal
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
                Many LLC owners assume their federal tax filing covers
                everything. It doesn’t. Here’s what makes
                <br /> California FTB Form 568 different from your IRS federal
                filing.
              </Typography>
              <Box component="div" sx={{ mb: 4, maxWidth: 900, m: 'auto' }}>
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    borderRadius: '16px',
                    border: '3px solid #8a69af',
                    overflow: 'hidden',
                    overflowX: 'auto',
                    boxShadow:
                      '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                  }}
                >
                  <Table
                    sx={{ minWidth: { xs: 500, sm: 650 } }}
                    aria-label="Due Date Chart"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          backgroundColor: '#5b0679',
                          borderBottom: '2px solid #8a69af',
                        }}
                      >
                        <TableCell
                          sx={{
                            color: '#ffffff',
                            fontWeight: 700,
                            width: { xs: 140, sm: 300 },
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 12, sm: 15 },
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                          }}
                        >
                          Category
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#ffffff',
                            fontWeight: 600,
                            width: { xs: 180, sm: 300 },
                            textAlign: 'center',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 16 },
                          }}
                        >
                          Federal LLC Return
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#ffffff',
                            fontWeight: 600,
                            width: { xs: 180, sm: 300 },
                            textAlign: 'center',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 16 },
                          }}
                        >
                          California LLC Form 568
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        sx={{ '&:hover': { backgroundColor: '#e2dceb' } }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: '#2f3742',
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            backgroundColor: '#e2dceb',
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #ffffff',
                          }}
                        >
                          Filed with
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          IRS
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          California FTB
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{ '&:hover': { backgroundColor: '#e2dceb' } }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: '#2f3742',
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            backgroundColor: '#e2dceb',
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          Who files
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          Depends on tax classification (Form 1065, 1120,
                          1120-S, or Schedule C)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          LLCs doing business in California, organized in
                          California, or earning California-source income
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{ '&:hover': { backgroundColor: '#e2dceb' } }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: '#2f3742',
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            backgroundColor: '#e2dceb',
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          Minimum tax
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            fontStyle: 'italic',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          None
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            fontWeight: 600,
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          $800 annual LLC tax
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{ '&:hover': { backgroundColor: '#e2dceb' } }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: '#2f3742',
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            backgroundColor: '#e2dceb',
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          LLC fee
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          None Allowed
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          Not applicable in California
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{ '&:hover': { backgroundColor: '#e2dceb' } }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: '#2f3742',
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            backgroundColor: '#e2dceb',
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          Apportionment
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          N/A
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: '3px solid #f1f5f9',
                          }}
                        >
                          Required if the LLC has business activity or income
                          both inside and outside California
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{ '&:hover': { backgroundColor: '#e2dceb' } }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: '#2f3742',
                            textAlign: 'left',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            backgroundColor: '#e2dceb',
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: 'none',
                          }}
                        >
                          Member Statements
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: 'none',
                          }}
                        >
                          Schedule K-1 (1065)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            color: '#2f3742',
                            padding: { xs: '12px 14px', sm: '20px 24px' },
                            fontSize: { xs: 13, sm: 15 },
                            borderBottom: 'none',
                          }}
                        >
                          Schedule K-1 (568)
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          pb: 6,
          pt: 1,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 2, mb: 2 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt: 2,
              }}
            >
              <Box
                component="div"
                // sx={{
                //   display: 'flex',
                //   justifyContent: 'center',
                //   alignItems: 'center',
                //   height: '100%',
                //   textAlign: { xs: 'center', md: 'right' },
                //   my: { xs: 3, md: 0 },
                // }}
                className="image-container"
              >
                <Box
                  component={motion.div}
                  key={currentIndex}
                  className="image-fade"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1.5, ease: 'easeInOut' }}
                  sx={{
                    '& img': {
                      width: '100% !important',
                      height: { xs: 'auto', md: 480 },
                    },
                  }}
                >
                  {images[currentIndex]}
                </Box>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 0 ? 'loading-effect' : ''}
                    id="loading1"
                  />{' '}
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 1 ? 'loading-effect' : ''}
                    id="loading2"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 2 ? 'loading-effect' : ''}
                    id="loading3"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 3 ? 'loading-effect' : ''}
                    id="loading4"
                  />
                  {/* <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#ac6ec6bc',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 4 ? 'loading-effect' : ''}
                    id="loading5"
                  /> */}
                </Stack>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box sx={{ ml: { md: 3, xs: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 1,
                    textAlign: 'left',
                  }}
                >
                  What You'll Need to File <br /> Form 568
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, ml: 3.5 }}>
                  Gather these details before you start:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 5 },
                    mt: { xs: 0, md: 2 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex', mb: 2 },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}> LLC Details:</span>{' '}
                      Legal name, FEIN, California Secretary of State file
                      number, and LLC classification for tax purposes 
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Income & Deductions:
                      </span>{' '}
                      California-source income, business revenue, cost of goods
                      sold, operating expenses, and deductible business costs 
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Member Information:
                      </span>{' '}
                      Name, TIN, ownership percentage, and distributions for
                      each LLC member
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Schedule K-1 Allocations:{' '}
                      </span>{' '}
                      Each member’s share of California income, deductions,
                      credits, and other tax items reported on Schedule K-1
                      (568) 
                    </Box>
                  </li>
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Balance Sheet Data:{' '}
                      </span>
                      Total assets, liabilities, and capital accounts at the
                      beginning and end of the tax year 
                    </Box>
                  </li>{' '}
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        LLC Fee & Tax Details:{' '}
                      </span>
                      Information needed to calculate the annual LLC tax and any
                      applicable California LLC fee based on total income from
                      California sources
                    </Box>
                  </li>{' '}
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Apportionment Details:{' '}
                      </span>
                      If the LLC operates in multiple states, Schedule R and
                      California apportionment data may be required
                    </Box>
                  </li>{' '}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={2}
            mb={2}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 5.5, sm: 12, lg: 5 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Eligibility Checklist — Does Your LLC Need to File Form 568?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Your LLC must file Form 568 if any of the following apply:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 0 },
                    mb: { xs: 0, md: 0 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      {' '}
                      Your LLC is{' '}
                      <span style={{ fontWeight: 600 }}>
                        organized in California
                      </span>
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your LLC is{' '}
                      <span style={{ fontWeight: 600 }}>
                        registered with the California Secretary of State
                      </span>
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your LLC is{' '}
                      <span style={{ fontWeight: 600 }}>
                        doing business in California
                      </span>
                      , even if it wasn’t originally formed here
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your LLC{' '}
                      <span style={{ fontWeight: 600 }}>
                        earns income from California
                      </span>{' '}
                      sources
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your LLC is treated as a{' '}
                      <span style={{ fontWeight: 600 }}>
                        partnership or disregarded entity
                      </span>{' '}
                      for tax purposes
                    </Box>
                  </li>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6.5, sm: 12, lg: 7 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f568-eligibility-checklist-img.webp" />
                  <source srcSet="/assets/images/f568-eligibility-checklist-img.png" />
                  <img
                    src="/assets/images/f568-eligibility-checklist-img.png"
                    alt="Eligibility Checklist — Does Your Partnership Need to File Form 568?"
                    className="img-responsive"
                    loading="lazy"
                    width={600}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={2}
            mb={5}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { md: 'row' } }}
          >
            <Grid
              size={{ md: 12, xs: 12 }}
              sx={{ mt: 2, justifyContent: 'center' }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 3,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                The $800 Annual LLC Tax - Don’t Miss It
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
                Unlike the IRS, California imposes an{' '}
                <span style={{ fontWeight: 600 }}>$800 annual LLC tax</span> on
                most LLCs required to file{' '}
                <span style={{ fontWeight: 600 }}>Form 568</span>. This applies
                even if your LLC:
              </Typography>
              <Box
                component="ul"
                sx={{
                  listStyle: 'none',
                  p: 0,
                  m: 0,
                  display: 'grid',
                  fontSize: 18,
                  gridTemplateColumns: {
                    xs: '1fr',
                    sm: '1fr 1fr',
                  },
                  gap: 2,
                  '& li': {
                    display: 'flex',
                    alignItems: 'flex-start',
                    p: 1.5,
                    border: '1px solid #E5E7EB',
                    borderRadius: 2,
                    backgroundColor: '#fff',
                  },
                }}
              >
                <li>
                  <CheckCircleRoundedIcon
                    sx={{ color: '#1da94a', mr: 1.2, mt: '2px', flexShrink: 0 }}
                  />
                  <Box>
                    Had <span style={{ fontWeight: 600 }}>zero revenue</span>
                  </Box>
                </li>

                <li>
                  <CheckCircleRoundedIcon
                    sx={{ color: '#1da94a', mr: 1.2, mt: '2px', flexShrink: 0 }}
                  />
                  <Box>
                    Operated at a{' '}
                    <span style={{ fontWeight: 600 }}>net loss</span>
                  </Box>
                </li>

                <li>
                  <CheckCircleRoundedIcon
                    sx={{ color: '#1da94a', mr: 1.2, mt: '2px', flexShrink: 0 }}
                  />
                  <Box>
                    Was{' '}
                    <span style={{ fontWeight: 600 }}>
                      inactive for the entire year
                    </span>
                  </Box>
                </li>

                <li>
                  <CheckCircleRoundedIcon
                    sx={{ color: '#1da94a', mr: 1.2, mt: '2px', flexShrink: 0 }}
                  />
                  <Box>
                    Filed a{' '}
                    <span style={{ fontWeight: 600 }}>
                      short-period return of less than 12 months
                    </span>
                  </Box>
                </li>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 12, lg: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'left' },
                  my: { xs: 3, md: 0 },
                  ml: { xs: 0, md: 2 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f568-annual-tax-img.webp" />
                  <source srcSet="/assets/images/f568-annual-tax-img.png" />
                  <img
                    src="/assets/images/f568-annual-tax-img.png"
                    alt="The $800 Annual LLC Tax — Don’t Miss It"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12, lg: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 0 } }}>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This{' '}
                  <span style={{ fontWeight: 600 }}>$800 annual LLC tax</span>{' '}
                  is generally due by{' '}
                  <span style={{ fontWeight: 600 }}>April 15</span> for
                  calendar-year LLCs, regardless of a filing extension. Pay it
                  using <span style={{ fontWeight: 600 }}>FTB Form 3522</span>{' '}
                  to avoid penalties and interest.
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    gap: 1.5,
                    flexDirection: { xs: 'column', md: 'row' },
                    mt: 2,
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      p: 1.5,
                      border: '1px solid #E5E7EB',
                      borderRadius: 2,
                      borderTop: '8px solid #16A34A',
                      bgcolor: '#fff',
                      minHeight: 165,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: '#16A34A',
                        mb: 0.8,
                      }}
                    >
                      Cancellation Exception
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        lineHeight: 1.65,
                        color: '#555',
                      }}
                    >
                      If your LLC files a{' '}
                      <span style={{ fontWeight: 600 }}>
                        timely final Form 568
                      </span>
                      , stops doing business in California, and submits
                      cancellation documents to the{' '}
                      <span style={{ fontWeight: 600 }}>
                        California Secretary of State within 12 months
                      </span>
                      , it will not owe the{' '}
                      <span style={{ fontWeight: 600 }}>
                        $800 annual LLC tax
                      </span>{' '}
                      for future years.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      p: 1.5,
                      border: '1px solid #E5E7EB',
                      borderRadius: 2,
                      borderTop: '8px solid #213e99',
                      bgcolor: '#fff',
                      minHeight: 165,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: '#213e99',
                        mb: 0.8,
                      }}
                    >
                      Final-Year Filing Note
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        lineHeight: 1.65,
                        color: '#555',
                      }}
                    >
                      If your LLC cancels or dissolves, may still need to file a
                      <span style={{ fontWeight: 600 }}>final Form 568</span>{' '}
                      for its last taxable year. The{' '}
                      <span style={{ fontWeight: 600 }}>
                        $800 annual LLC tax may still apply
                      </span>{' '}
                      unless a California exception applies.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'row', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Form 568 Filing Deadlines — 2025 Tax Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Find the original and extended filing deadlines for Form 568
                  based on your LLC’s tax classification.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table aria-label="LLC Filing Due Dates">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell
                            sx={{ color: '#444', width: 350, fontWeight: 600 }}
                          >
                            LLC Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 220, fontWeight: 600 }}
                          >
                            Original Due Date
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 220, fontWeight: 600 }}
                          >
                            Extended Filing Due Date
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>
                            Single-member LLC (owned by an individual or
                            non-pass-through entity)
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            April 15, 2026
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            October 15, 2026
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Multi-member LLC (taxed as a partnership)
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            March 16, 2026 <br />
                            <Typography component="span" variant="body2">
                              (March 15 falls on a Sunday)
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            October 15, 2026
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>
                            Single-member LLC owned by an S corporation
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            March 16, 2026
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            September 15, 2026
                          </TableCell>
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Single-member LLC owned by a partnership or other
                            pass-through entity
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            March 16, 2026
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: 16 }}>
                            October 15, 2026
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 12, sm: 12, lg: 12 }}
              sx={{ mx: { xs: 0, sm: 2, md: 24 } }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  minHeight: '100%',
                  backgroundColor: '#f2e9e4',
                }}
                className="pattern-bg"
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 20, xs: 18 },
                    mb: 1,
                    fontWeight: 600,
                  }}
                >
                  For Fiscal Year:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For{' '}
                  <span style={{ fontWeight: 600 }}>
                    fiscal-year LLCs, Form 568
                  </span>{' '}
                  is generally due on the 15th day of the 3rd month after
                  year-end (partnership LLCs) or the{' '}
                  <span style={{ fontWeight: 600 }}>
                    15th day of the 4th month
                  </span>{' '}
                  (certain single-member LLCs). California grants an{' '}
                  <span style={{ fontWeight: 600 }}>
                    automatic 7-month filing extension
                  </span>
                  , but payments are still due by the original deadline.
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  Examples:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If your fiscal year ends{' '}
                  <span style={{ fontWeight: 600 }}>May 31, 2026</span>, Form
                  568 is due{' '}
                  <span style={{ fontWeight: 600 }}>August 15, 2026</span>; the
                  extended filing deadline is{' '}
                  <span style={{ fontWeight: 600 }}>March 16, 2027</span>.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to File Form 568 with TaxZerone
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing your Form 1065 is quick and streamlined—just follow these
                steps:
              </Typography> */}
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/f568-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/f568-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/f568-steps-img.png"
                  alt="How to File Form 568 with TaxZerone "
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Step 1 — Create Your TaxZerone Account"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 1 – Begin With Your Federal Return
                    </Typography>
                    <Typography variant="body1">
                      Complete your federal Form 1065 first, and TaxZerone
                      automatically transfers your business, member, income,
                      deduction, and tax details to{' '}
                      <span style={{ fontWeight: 600 }}>CA FTB Form 568</span>{' '}
                      return.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Step 2 — Enter Partnership & Partner Details"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 2. Review and Update Your Form 568 Information
                    </Typography>
                    <Typography variant="body1">
                      Open Form 568 and review the LLC details that are
                      prefilled. If there are any state specific changes or
                      corrections, you can easily edit the imported information
                      before filing.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Step 3 — Report Income, Deductions & Credits"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 3 — ile with the FTB
                    </Typography>
                    <Typography variant="body1">
                      You can securely file your Form 568 directly with the
                      California Franchise Tax Board (FTB) via TaxZerone.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-4-icon.webp" />
                        <source srcSet="/assets/images/step-4-icon.png" />
                        <img
                          src="/assets/images/step-4-icon.png"
                          alt="Step 4 — Validate Before You File"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Step 4 — Download and Share Schedule K-1
                    </Typography>
                    <Typography variant="body1">
                      Once filed, download Schedule K-1 (568) and securely share
                      with members of LLC using{' '}
                      <span style={{ fontWeight: 600 }}>ZeroneVault</span>{' '}
                      (Secure Portal) or by mail copies.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    mb: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form568`}
                >
                  File Form 568
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 568?
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="FTB-Compliant Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FTB-Compliant Filing
                </Typography>
                <Typography variant="body1">
                  File directly with the California Franchise Tax Board on a
                  platform built for state-level accuracy and compliance.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Step-by-Step Workflow"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Step-by-Step Workflow
                </Typography>
                <Typography variant="body1">
                  Whether you're filing{' '}
                  <span style={{ fontWeight: 600 }}>Form 568</span> for the
                  first time or the tenth, our system walks you through every
                  section — no tax expertise required.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="Auto-Generated Schedule K-1 (565)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Auto-Generated Schedule K-1 (568)
                </Typography>
                <Typography variant="body1">
                  Member K-1s are created automatically from your return data
                  and ready for immediate digital or postal delivery.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="Transparent Flat-Fee Pricing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Automatic Federal Data Import
                </Typography>
                <Typography variant="body1">
                  If you filed your federal Form 1065 with TaxZerone, your
                  information is automatically imported into your California LLC
                  Form 568, reducing manual data entry and helping you file
                  faster.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Advanced Error Checks "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Advanced Error Checks
                </Typography>
                <Typography variant="body1">
                  We scan for missing information, calculation errors, and
                  California-specific compliance issues before your return
                  reaches the FTB.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Support Team"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Dedicated Support Team
                </Typography>
                <Typography variant="body1">
                  Have a California-specific question? Our support team is
                  available via chat, email, and phone to help you file with
                  confidence.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/1120s-tax-professional-img.webp" />
                  <source srcSet="/assets/images/1120s-tax-professional-img.png" />
                  <img
                    src="/assets/images/1120s-tax-professional-img.png"
                    alt="Special Pricing for CPAs & Tax Professionals"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  Special Pricing for CPAs & Tax Professionals
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  Filing Form 568 for multiple California LLC? TaxZerone offers
                  exclusive bulk pricing, reusable client profiles, and
                  dedicated support for tax professionals managing high-volume
                  filings.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Bigger filings = Bigger discounts </li>
                  <li>
                    Save time with reusable business profiles across clients
                  </li>
                  <li>White-glove support during peak filing season</li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  📞{' '}
                  <Link
                    // href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1065`}
                    href="/contact-us/"
                    sx={{ color: '#0202ff' }}
                  >
                    Contact Us Now
                  </Link>{' '}
                  to unlock your custom CPA pricing and make this California
                  filing season your smoothest yet.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  border: 'none',
                  maxWidth: 950,
                  m: 'auto',
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Common Mistakes to Avoid
                </Typography>

                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    Skipping Form 568 California because the LLC had no income
                  </li>
                  <li>Missing the $800 Annual LLC Tax payment</li>
                  <li>
                    Confusing the Annual LLC Tax with the California LLC Fee
                  </li>
                  <li>Using the wrong LLC classification on the return</li>
                  <li>Reporting the wrong California-source income</li>
                  <li>
                    Using incorrect ownership percentages when allocating income
                    or loss on Schedule K-1s
                  </li>
                  <li>
                    Forgetting to file a final return after cancellation or
                    dissolution
                  </li>
                  <li>
                    Assuming a federal extension covers California LLC tax
                    payments
                  </li>
                  <li>
                    Filing the return without reviewing FTB-specific schedules
                    and questions
                  </li>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          File California Form 568 Before the Deadline
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Prepare your return, generate shareholder K-1s, and meet California
          filing requirements with TaxZerone.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form568`}
          >
            E-File Form 568
          </Button>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="f568-faq"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2 } }}
          >
            <Grid
              size={{ xs: 12, md: 9, sm: 10 }}
              textAlign="left"
              my={{ xs: 2, sm: 5 }}
              mb={3}
            >
              <Typography
                id="f568-faq"
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>
              <Box
                component="div"
                sx={{ mb: 5 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is Form 568 for a California LLC?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          <span style={{ fontWeight: 600 }}>Form 568</span> is
                          the California tax return used by{' '}
                          <span style={{ fontWeight: 600 }}>
                            limited liability companies
                          </span>{' '}
                          (LLCs) to report income, pay the{' '}
                          <span style={{ fontWeight: 600 }}>
                            annual LLC tax
                          </span>
                          , and calculate any{' '}
                          <span style={{ fontWeight: 600 }}>
                            California LLC fee
                          </span>{' '}
                          that may be due.
                        </li>
                        <li>
                          If your LLC is organized in California, registered in
                          California, doing business in California, or earning
                          California-source income, you may need to file{' '}
                          <span style={{ fontWeight: 600 }}>Form 568</span> with
                          the California Franchise Tax Board (FTB).{' '}
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What are the filing deadlines for Form 568?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="p" sx={{ mt: 1 }}>
                        The due date for{' '}
                        <span style={{ fontWeight: 600 }}>CA Form 568</span>{' '}
                        depends on how your LLC is taxed.
                      </Typography>
                      <Box
                        component="ul"
                        sx={{ mb: 0, mt: 1, '& li': { mb: 1.2 } }}
                      >
                        <li>
                          <span style={{ fontWeight: 600 }}>LLCs:</span> due on
                          the 15th day of the 3rd month after the close of the
                          tax year. For a calendar-year LLC, the 2025 Form 568
                          is due{' '}
                          <span style={{ fontWeight: 600 }}>
                            March 16, 2026
                          </span>
                          .
                        </li>
                        <li>
                          <span style={{ fontWeight: 600 }}>
                            Single-member LLCs:
                          </span>{' '}
                          due on the 15th day of the 4th month after the close
                          of the tax year. For a calendar-year LLC, the 2025
                          Form 568 is due{' '}
                          <span style={{ fontWeight: 600 }}>
                            April 15, 2026
                          </span>
                          .
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which online services help with filing form 568?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          California LLCs can use several online tax filing
                          services to prepare and file Form 568. These platforms
                          will generally walk you through reporting LLC income,
                          California-source income, annual LLC tax, LLC fee, and
                          required member information.
                        </li>
                        <li>
                          If you&apos;re looking for an easier approach,
                          TaxZerone helps eligible California LLCs prepare and
                          file Form 568 online with step-by-step guidance and
                          support for required California LLC tax reporting.
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35) !important',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    How do I file a CA Form 568 extension?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                      California grants an automatic extension to file{' '}
                      <Link
                        href="https://www.ftb.ca.gov/forms/2025/2025-568.pdf"
                        sx={{ color: '#0202ff' }}
                        target="_blank"
                      >
                        CA FTB Form 568
                      </Link>{' '}
                      without requiring a separate extension request. LLCs
                      classified as partnerships generally receive a seven-month
                      extension from the original due date. Single-member LLCs
                      (SMLLCs) generally receive a{' '}
                      <span style={{ fontWeight: 600 }}>
                        six-month extension
                      </span>
                      .
                    </Typography>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35) !important',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Does a single-member LLC need to file Form 568 in
                    California?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                      Yes. A single-member LLC generally must file Form 568 if
                      it is doing business in California, registered in
                      California, or earns California-source income. Even if
                      it&apos;s treated as a disregarded entity for federal tax
                      purposes, California may still require Form 568 filing.
                      The LLC may also owe the{' '}
                      <span style={{ fontWeight: 600 }}>
                        $800 annual LLC tax
                      </span>{' '}
                      and, in some cases, an additional LLC fee.
                    </Typography>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35) !important',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Does a filing extension also extend my payment deadline for
                    Form 568?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                      A{' '}
                      <span style={{ fontWeight: 600 }}>
                        California Form 568 extension
                      </span>{' '}
                      only extends the time to file the return; it does not
                      extend the deadline to pay any taxes or fees due. LLCs are
                      required to pay the required California LLC annual tax and
                      any fees by the original payment deadline to avoid
                      penalties and interest.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default Form565;
